import React, { useEffect, useState, } from 'react'
import Main from '../cpn/Main'
import { Form, App, Modal, Space, Table,  Rate } from 'antd'
import GetUser from '../cpn/GetUser'
import { useRenwuDelMutation, useRenwuListQuery } from '../store/BnsKeJiApi'
import ModalDel from '../cpn/ModalDel'
import TaskEdit from './TaskEdit'
import TaskAddCopy from './TaskAddCopy'
import TaskCheck from './TaskCheck'

function TaskList() {
    const e_id = JSON.parse(localStorage.getItem('e_id'))
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const {message} = App.useApp()
    const [list,setList] = useState([])
    const {data,isSuccess} = useRenwuListQuery({
        rw_e_id:"218"
    })
    useEffect(() => {
        if(isSuccess && data.Status==='success'){
            const arr = data.Result.map((item) => ({
                key:item.rw_id,
                rw_name:item.rw_name,
                rw_content:item.rw_content,
                rw_js_uname:item.rw_js_uname,
                rw_js_uid:item.rw_js_uid,
                rw_fb_uname:item.rw_fb_uname,
                rw_fb_id:item.rw_fb_id,
                rw_ctime:item.rw_ctime,
                rw_end_date:item.rw_end_date,
                rw_state:item.rw_state,
                rw_dept_id:item.rw_dept_id,
                rw_e_id:item.rw_e_id,
                rw_uid:item.rw_uid,
                rw_uname:item.rw_uname,
                rw_js_content:item.rw_js_content,
                rw_js_update_time:item.rw_js_update_time,
                rw_pj_content:item.rw_pj_content,
                rw_pj_update_time:item.rw_pj_update_time,
                rw_pj_tate:item.rw_pj_tate,
              
            }))
            setList(arr)
        }
    },[data,isSuccess])
    const [modalInfo,setModalInfo] = useState({
        open:false,
        title:"",
        content:''
    })
    //删除
    const [del] = useRenwuDelMutation()
    const columns = [
        {
            title:"状态",       
            dataIndex:'rw_state',
            key:'rw_state', 
            render:(text) => {
                let color, title;
                if (text==='1') {
                    color = '#0066FF';
                    title = '待验收';
                } else if (text==='2') {
                    color = '#FFCC00';
                    title = '待评价';
                } else if (text==='3') {
                    color = '#00CC00';
                    title = '已结束';
                }
                return <Space><div style={{ background: color, width: "20px", height: "20px", borderRadius: "20px" }}></div> {title}</Space>
            }                
        },
        {
            title:"团队任务", 
            dataIndex:'rw_name',
            key:'rw_name',  
        },        
        {
            title:"发布人", 
            dataIndex:'rw_js_content',
            key:'rw_js_content',  
            render:(_,record) => <div>{record.rw_fb_uname} {record.rw_ctime}</div>                
        },
        {
            title:"接收人", 
            dataIndex:'rw_js_uname',
            key:'rw_js_uname',  
        },
        {
            title:"截止日期", 
            dataIndex:'rw_end_date',
            key:'rw_end_date',  
        },
        {
            title:"评分", 
            dataIndex:'rw_pj_tate',
            key:'rw_pj_tate',  
            render:(_,record) => <Rate value={record.rw_pj_tate} disabled/>
        },         
        {
            title:"操作",                        
            key:'action',   
            render:(_,record) => {
                return <Space>
                    <TaskCheck rw_name={record.rw_name} rw_id={record.key} rw_uid={record.rw_uid} eu_id={eu_id} rw_pj_content={record.rw_pj_content}/>                
                    {(eu_id === +record.rw_uid && record.rw_state!=='3') && <TaskEdit rw_id={record.key} eu_id={eu_id} eu_name={eu_name}/>}
                    {(eu_id === +record.rw_uid && record.rw_state!=='3') && <ModalDel onOk={() => {
                        del({rw_id:record.key}).then((res) => {
                            if (res.data.Status === 'success') {
                                message.success('删除成功！')                                                                              
                            }
                            if (res.data.Status === 'fail') {
                                message.error('删除失败！'+res.data.Message)
                            }
                        })
                    }} />}
                    {eu_id === +record.rw_uid && <TaskAddCopy
                        rw_name={record.rw_name}
                        rw_content={record.rw_content}
                        rw_fb_uname={record.rw_fb_uname}
                        rw_fb_id={record.rw_fb_id}
                        rw_js_uname={record.rw_js_uname}
                        rw_js_id={record.rw_js_id}
                        rw_dept_id={record.rw_dept_id}
                        rw_e_id={record.rw_e_id}
                        rw_end_date={record.rw_end_date}
                        rw_uid={record.rw_uid}
                        rw_uname={record.rw_uname}
                        eu_id={eu_id}
                        eu_name={eu_name}
                        e_id={e_id}
                    />}
                </Space>
            }  
        },
    ]
    return (
        <Main selectedKeys={['/TaskAdd']}>
            <div>
                <Form
                    layout='inline'
                    wrapperCol={{span:"10"}}
                >   
                    <GetUser
                        getUser={() => {}}
                        style={{width:"200px"}}
                    />
                </Form>
            </div>
            <Table
                columns={columns}
                dataSource={list}
            />
            <Modal
                open={modalInfo.open}
                onCancel={() => {
                    setModalInfo({open:false})
                }}
                title={modalInfo.title}
            >
                <div dangerouslySetInnerHTML={{__html:modalInfo.content}}></div>
            </Modal>
        </Main>
    )
}

export default TaskList